import { VideoModalProps } from 'components/VideoModal/Types'
import { Modal, useModals } from 'almanac-ui/Modal'
import Styles from './VideoModal.module.scss'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { Button } from 'blaze-ui/Button'

export const VideoModal = ({ embedId }: VideoModalProps) => {
  const { isMobile } = useResponsiveDesign()
  const { closeAllModals, closeModal } = useModals()

  return (
    <Modal.Root size="lg" wrapperClassName={Styles.root} onPressOutside={closeModal}>
      <div className={Styles.body}>
        <div className={Styles.video}>
          <iframe
            className={Styles.iframe}
            src={`https://www.youtube.com/embed/${embedId}`}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Embedded youtube"
          />
        </div>
      </div>
      {isMobile && (
        <Modal.Footer>
          <Modal.FooterContent slot="left">
            <Button size="xl" onPress={closeAllModals}>
              Close
            </Button>
          </Modal.FooterContent>
        </Modal.Footer>
      )}
    </Modal.Root>
  )
}
